import React, { useState } from "react";
import NavBar from "./components/NavBar";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { routes } from "./constants/Routes";
import StartPage from "./pages/StartPage";
import { Components } from "./Components";
import { MainPage } from "./pages/MainPage";
import { ResultContext } from "./ResultContext";
import { ContactPage } from "./pages/ContactPage";
import { MobileOverlay } from "./components/MobileOverlay";

export default function App() {
  const [results, setResults] = useState({});
  return (
    <>
      <ResultContext.Provider
        value={{
          setResult: (r) => {
            setResults(r);
          },
          result: results,
        }}
      >
        <BrowserRouter>
          <NavBar />
          <Routes>
            <Route path={routes.start} element={<StartPage />} />
            <Route path={routes.help} element={<ContactPage />} />
            <Route path={routes.main} element={<MainPage />} />
            <Route path={routes.components} element={<Components />} />
          </Routes>
          <MobileOverlay />
        </BrowserRouter>
      </ResultContext.Provider>
    </>
  );
}
